/**
 * The class joiner, one implementation for the app.
 *
 * Coach web uses `clsx`; this app cannot add a dependency (node_modules is shared with the other
 * checkout and never installed from here), and the whole of what the atoms use is "join the
 * truthy ones", so it lives here rather than being written inline at every call site.
 */
export type ClassValue =
  | string
  | number
  | null
  | undefined
  | false
  | Record<string, boolean | null | undefined>
  | ClassValue[];

export function cx(...values: ClassValue[]): string {
  const out: string[] = [];
  for (const value of values) {
    if (!value) continue;
    if (typeof value === "string" || typeof value === "number") {
      out.push(String(value));
    } else if (Array.isArray(value)) {
      const nested = cx(...value);
      if (nested) out.push(nested);
    } else {
      for (const [key, on] of Object.entries(value)) if (on) out.push(key);
    }
  }
  return out.join(" ");
}
